import { useParams, useSearchParams } from 'react-router-dom';
import { MonthParams } from '../../types';

export function useRouteParams() {
  const { year, month } = useParams<MonthParams>();

  const [searchParams] = useSearchParams();
  const jahr = parseInt(searchParams.get('jahr')) || undefined;
  const monat = parseInt(searchParams.get('monat')) || undefined;

  return {
    routeParams: {
      jahr: parseInt(year),
      monat: parseInt(month),
    },
    searchParams: { jahr, monat },
  };
}
